(function () {
  function initProductVideoOverlay() {
    const widget = document.getElementById('PVO-Widget');
    const modal = document.getElementById('PVO-Modal');
    if (!widget || !modal) return;

    if (widget.dataset.initialized === 'true') return;
    widget.dataset.initialized = 'true';

    // Move modal to body to break out of containing blocks with transform/filters
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    const videoUrl = widget.dataset.videoUrl;
    const player = modal.querySelector('.pvo-video-player');
    const closeBtn = modal.querySelector('.pvo-modal-close');
    const overlay = modal.querySelector('.pvo-modal-overlay');

    // Anchor widget to the first media item so it scrolls away naturally
    const firstMedia = document.querySelector('.product__media-list .product__media-item:first-child') ||
      document.querySelector('.slider__slide:first-child') ||
      document.querySelector('.product__media-wrapper .product__media-item');

    if (firstMedia) {
      firstMedia.style.position = 'relative';
      firstMedia.appendChild(widget);
    } else {
      // Fallback to gallery wrapper
      const mediaGallery = document.querySelector('.product__media-wrapper') ||
        document.querySelector('media-gallery') ||
        document.querySelector('.product__media-list')?.parentElement;
      if (mediaGallery) {
        mediaGallery.style.position = 'relative';
        mediaGallery.appendChild(widget);
      }
    }

    // Always visible because it's now bound to the exact image element
    widget.classList.add('pvo-visible');

    function openModal() {
      if (!player.src || player.src !== videoUrl) {
        player.src = videoUrl;
      }
      modal.classList.remove('pvo-hidden');
      document.body.style.overflow = 'hidden';
      player.play().catch(e => console.warn('PVO auto-play hindered:', e));
    }

    function closeModal() {
      modal.classList.add('pvo-hidden');
      document.body.style.overflow = '';
      player.pause();
      player.removeAttribute('src'); // Prevent background downloading/buffering
      player.load();
    }

    const widgetCloseBtn = widget.querySelector('.pvo-widget-close');
    function hideWidgetEntirely(e) {
      e.stopPropagation(); // prevent modal from opening
      widget.classList.remove('pvo-visible');
      setTimeout(() => widget.remove(), 300); // Fully remove the element after fade-out transition
    }

    widget.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);

    if (widgetCloseBtn) {
      widgetCloseBtn.addEventListener('click', hideWidgetEntirely);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.classList.contains('pvo-hidden')) {
        closeModal();
      }
    });
  }

  // Initialize after DOM loads, or immediately if already loaded
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initProductVideoOverlay();
  } else {
    document.addEventListener('DOMContentLoaded', initProductVideoOverlay);
  }

  // Handle Shopify theme editor block interactions
  document.addEventListener('shopify:section:load', initProductVideoOverlay);
  document.addEventListener('shopify:block:select', function (event) {
    if (event.target.querySelector('#PVO-Widget')) {
      initProductVideoOverlay();
    }
  });
})();
